import * as firebase from "firebase"
require("firebase/storage")

export const getUrlVideo = video => {
  let reference = firebase.storage().ref(video)
  return (
    reference.getDownloadURL()
      .then(url => {
        return url
      })
      .catch(error => {
        console.log('ERROR', error.message)
      })
  )
}

export const getUrlImage = (image, type, thumbnail, return_default) => {
  if (!image) {
    let name = null
    if (thumbnail && !return_default) {
      switch (type) {
        case 'category':
          name = '150x150'
          break;
        case 'component':
          name = '480x360'
          break;
        case 'video':
        default:
          name = '400x225'
          break;
      }
    } else if (thumbnail && return_default) {
      name = type
    }
    image = 'default/' + name + '.jpg'
  }
  let reference = firebase.storage().ref(image)

  return (
    reference.getDownloadURL()
      .then(url => {
        return url
      })
      .catch(error => {
        console.log('ERROR', image, error.message)
      })
  )
}

export const uploadImage = (id, type, file) => {
  let reference = firebase.storage().ref(type + '/' + id + '.jpg')
  return reference
    .put(file)
    .then(snapshot => {
      return snapshot
    })
}

export const uploadVideo = (id, type, file) => {
  let reference = firebase.storage().ref(type + '/' + id + '.mp4')
  return reference.put(file)

  // var uploadTask = reference.put(file)
  // return uploadTask
  // .on('state_changed', snapshot => {
  //   let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
  //   progress = Math.ceil(progress)
  //   callback(progress)
  // },
  // error => {
  //   console.log('Error uploading video', error)
  // },
  // snapshot => {
  //   return snapshot
  // })

  // Idea for delete validation
  // uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
  //   console.log('File available at', downloadURL);
  // })

  // return uploadResource(id, type, file, 'mp4', callback)
}

export const uploadResource = (id, type, file, extension, callback) => {
  let reference = firebase.storage().ref(type + '/' + id + '.' + extension)
  return reference
    .put(file)
    .on('state_changed', snapshot => {
      if (callback) {
        let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        progress = Math.ceil(progress)
        callback(progress)
      }
    })
    .then(snapshot => {
      return snapshot
    })
    .catch(error => {
      console.log('C', error)
    })
}

export const removeImage = (id, type) => {
  return removeResource(id, type, 'jpg')
  // let reference = firebase.storage().ref(type + '/' + id + '.jpg')
  // return reference
  //   .delete()
  //   .then(snapshot => {
  //     return snapshot
  //   })
  //   .catch(error => {
  //     console.log('Error:', error.message)
  //   })
}

export const removeVideo = (id, type) => {
  return removeResource(id, type, 'mp4')
}

const removeResource = (id, type, extension) => {
  let reference = firebase.storage().ref(type + '/' + id + '.' + extension)

  return reference.getDownloadURL()
  .then(() => {
    return reference
      .delete()
      .then(snapshot => {
        return snapshot
      })
      .catch(error => {
        console.log('Error:', error.message)
      })
  }).catch(error => {
    console.log('Error File Not Found:', error.message)
  })
}

export const getCategoryExampleThumbnail = () => {
  let reference = firebase.storage().ref('default/150x150.jpg')

  return (
    reference.getDownloadURL()
      .then(url => {
        return url
      })
      .catch(error => {
        console.log('ERROR', error.message)
      })
  )
}

export const getDefaultCategoryThumbnail = () => {
  return firebase.storage().ref('default/category.jpg')
}
